export interface SiteStat {
  label: string;
  value: string;
  hint: string;
}

export interface TopicItem {
  id: string;
  name: string;
  icon: string;
  count: string;
  desc: string;
  tint: "primary" | "accent" | "secondary";
}

export interface CollectionItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  tags: string[];
  entries: number;
  updated: string;
  badge: string;
}

export interface ArchiveItem {
  id: string;
  title: string;
  category: string;
  date: string;
  size: string;
  views: string;
  hot: boolean;
}

export interface RankItem {
  id: string;
  name: string;
  heat: string;
  trend: string;
  up: boolean;
}

export interface DiscussionItem {
  id: string;
  title: string;
  author: string;
  avatar: string;
  tag: string;
  replies: number;
  likes: number;
  time: string;
}

export const siteStats: SiteStat[] = [
  { label: "主题分类", value: "32", hint: "持续增补" },
  { label: "合集归档", value: "1,286", hint: "按主题整理" },
  { label: "本周新增", value: "48", hint: "周一更新" },
  { label: "资料条目", value: "5,420", hint: "含背景脉络" },
];

export const notices: string[] = [
  "本周新增 12 组主题合集归档，索引页已同步刷新",
  "「年度娱乐话题」专题补录背景脉络章节，可重新查阅",
  "下载入口已按主题分区合并，查找归档更快一步",
  "讨论区新增「整理建议」板块，欢迎补充主题线索",
];

export const topics: TopicItem[] = [
  { id: "t1", name: "娱乐观察", icon: "ri-movie-2-line", count: "128 组合集", desc: "话题脉络与时间线梳理", tint: "primary" },
  { id: "t2", name: "网络热点", icon: "ri-fire-line", count: "96 组合集", desc: "热梗起源与传播路径", tint: "accent" },
  { id: "t3", name: "商业动态", icon: "ri-line-chart-line", count: "74 组合集", desc: "品牌事件与案例归档", tint: "secondary" },
  { id: "t4", name: "科技圈", icon: "ri-cpu-line", count: "61 组合集", desc: "产品争议与技术讨论", tint: "primary" },
  { id: "t5", name: "体坛风云", icon: "ri-basketball-line", count: "52 组合集", desc: "焦点赛事与背景资料", tint: "accent" },
  { id: "t6", name: "生活方式", icon: "ri-leaf-line", count: "43 组合集", desc: "日常话题与文化观察", tint: "secondary" },
  { id: "t7", name: "话题存档", icon: "ri-archive-2-line", count: "88 组合集", desc: "长期追踪的旧案归档", tint: "primary" },
  { id: "t8", name: "图文资料", icon: "ri-gallery-line", count: "117 组合集", desc: "图文材料集中查阅", tint: "accent" },
];

export const collections: CollectionItem[] = [
  {
    id: "c1",
    title: "年度娱乐话题专题合集",
    summary: "把一年里讨论度最高的娱乐话题按时间顺序排好，附上关键节点、相关方回应与传播脉络，适合一次性集中查阅。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20in%20warm%20crimson%20red%20and%20amber%20gold%20tones%2C%20layered%20paper%20cut%20shapes%20with%20subtle%20film%20grain%2C%20deep%20charcoal%20background%20and%20soft%20vignette%2C%20dramatic%20side%20lighting%2C%20minimal%20geometric%20composition%2C%20no%20people%2C%20high%20detail%2C%20moody%20magazine%20cover%20aesthetic&width=800&height=520&seq=hlb-cover-01&orientation=landscape",
    tags: ["时间线", "背景脉络", "图文"],
    entries: 42,
    updated: "09-08 更新",
    badge: "本周主推",
  },
  {
    id: "c2",
    title: "网络热梗演变资料归档",
    summary: "从最初的一条动态到全网模仿，记录热梗的起源、变体与二次创作，配套关键截图与出处说明。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20digital%20glitch%20artwork%20with%20warm%20orange%20and%20deep%20red%20gradient%20blocks%2C%20fragmented%20pixel%20shards%20and%20halftone%20dots%20on%20dark%20background%2C%20warm%20analog%20palette%2C%20dynamic%20diagonal%20composition%2C%20no%20people%2C%20cinematic%20grain%2C%20modern%20editorial%20cover%20style&width=800&height=520&seq=hlb-cover-02&orientation=landscape",
    tags: ["热梗", "传播路径", "出处"],
    entries: 31,
    updated: "09-06 更新",
    badge: "热度上升",
  },
  {
    id: "c3",
    title: "品牌营销案例整理合集",
    summary: "汇总近半年引发讨论的品牌传播事件，按起因、发酵、回应三段式整理，方便做案例复盘。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20still%20life%20of%20stacked%20blank%20paper%20cards%20and%20geometric%20blocks%20in%20copper%20brown%20and%20cream%2C%20warm%20studio%20lighting%2C%20deep%20shadow%20background%2C%20minimal%20product%20editorial%20composition%2C%20no%20people%2C%20refined%20texture%2C%20high%20detail%20magazine%20cover&width=800&height=520&seq=hlb-cover-03&orientation=landscape",
    tags: ["案例复盘", "三段式", "整理"],
    entries: 27,
    updated: "09-05 更新",
    badge: "广受关注",
  },
  {
    id: "c4",
    title: "科技圈争议时间线合集",
    summary: "围绕有争议的产品与话题，按时间轴梳理关键发布、公开回应与后续进展，资料随事件推进持续补录。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20circuit%20like%20geometric%20pattern%20in%20warm%20terracotta%20red%20and%20sand%20gold%2C%20glowing%20thin%20lines%20on%20dark%20charcoal%20surface%2C%20macro%20detail%2C%20symmetrical%20minimal%20composition%2C%20no%20people%2C%20cinematic%20depth%20of%20field%2C%20editorial%20tech%20cover&width=800&height=520&seq=hlb-cover-04&orientation=landscape",
    tags: ["时间轴", "产品", "回应"],
    entries: 19,
    updated: "09-03 更新",
    badge: "持续跟进",
  },
  {
    id: "c5",
    title: "体坛焦点事件脉络",
    summary: "聚焦赛场内外的讨论焦点，整理赛程节点、媒体报道与网友观点，作为浏览赛事背景的集中入口。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20dynamic%20motion%20blur%20of%20warm%20amber%20and%20red%20ribbons%20swirling%20on%20dark%20backdrop%2C%20high%20contrast%20dramatic%20lighting%2C%20energetic%20diagonal%20composition%2C%20no%20people%2C%20fine%20grain%20texture%2C%20sports%20magazine%20cover%20aesthetic&width=800&height=520&seq=hlb-cover-05&orientation=landscape",
    tags: ["赛事", "观点", "脉络"],
    entries: 23,
    updated: "09-01 更新",
    badge: "话题热门",
  },
  {
    id: "c6",
    title: "经典名场面图文存档",
    summary: "把流传较广的经典片段与图文材料集中收纳，标注大致出处与流传时间，方便按主题翻阅与比对。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20stacked%20vintage%20photo%20frames%20and%20torn%20paper%20edges%20in%20warm%20sepia%20and%20crimson%2C%20moody%20dark%20background%20with%20soft%20spotlight%2C%20nostalgic%20collage%20texture%2C%20no%20people%2C%20high%20detail%2C%20editorial%20archive%20cover&width=800&height=520&seq=hlb-cover-06&orientation=landscape",
    tags: ["存档", "图文", "出处"],
    entries: 36,
    updated: "08-30 更新",
    badge: "常被查阅",
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Abstract%20warm%20dark%20textured%20background%20of%20layered%20crimson%20and%20amber%20ink%20washes%2C%20subtle%20film%20grain%20and%20paper%20texture%2C%20soft%20radial%20light%20from%20the%20top%2C%20moody%20editorial%20atmosphere%2C%20wide%20cinematic%20composition%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=hlb-hero-bg&orientation=landscape";

export const archiveItems: ArchiveItem[] = [
  { id: "a1", title: "某综艺剪辑争议合集（时间线版）", category: "娱乐观察", date: "09-08", size: "PDF · 18.6 MB", views: "3.2 万", hot: true },
  { id: "a2", title: "夏季热梗传播路径整理", category: "网络热点", date: "09-07", size: "PDF · 12.4 MB", views: "2.7 万", hot: true },
  { id: "a3", title: "新消费品牌翻车案例摘录", category: "商业动态", date: "09-06", size: "ZIP · 26.1 MB", views: "1.9 万", hot: false },
  { id: "a4", title: "智能硬件发布会争议节点", category: "科技圈", date: "09-05", size: "PDF · 9.8 MB", views: "1.5 万", hot: false },
  { id: "a5", title: "焦点赛事相关报道汇编", category: "体坛风云", date: "09-04", size: "PDF · 15.2 MB", views: "1.1 万", hot: false },
  { id: "a6", title: "经典片段出处比对表", category: "图文资料", date: "09-02", size: "XLSX · 3.4 MB", views: "9,860", hot: false },
  { id: "a7", title: "长期追踪话题旧案归档（第二批）", category: "话题存档", date: "08-31", size: "ZIP · 41.7 MB", views: "8,420", hot: false },
];

export const rankItems: RankItem[] = [
  { id: "r1", name: "年度娱乐话题专题合集", heat: "9,860", trend: "+12%", up: true },
  { id: "r2", name: "网络热梗演变资料归档", heat: "8,240", trend: "+9%", up: true },
  { id: "r3", name: "经典名场面图文存档", heat: "7,110", trend: "+4%", up: true },
  { id: "r4", name: "品牌营销案例整理合集", heat: "6,380", trend: "-2%", up: false },
  { id: "r5", name: "科技圈争议时间线合集", heat: "5,470", trend: "+6%", up: true },
];

export const discussions: DiscussionItem[] = [
  {
    id: "d1",
    title: "整理一下今年的娱乐话题，感觉有几个节点被忽略了",
    author: "路过的整理党",
    avatar: "整",
    tag: "主题建议",
    replies: 42,
    likes: 318,
    time: "2 小时前",
  },
  {
    id: "d2",
    title: "热梗的时间线是不是可以再往前推两个月？",
    author: "梗百科",
    avatar: "梗",
    tag: "资料补充",
    replies: 27,
    likes: 204,
    time: "5 小时前",
  },
  {
    id: "d3",
    title: "下载入口能不能按主题分区合并一下，找起来更顺",
    author: "找料的人",
    avatar: "找",
    tag: "体验反馈",
    replies: 18,
    likes: 156,
    time: "昨天",
  },
  {
    id: "d4",
    title: "分享一个自己整理的事件脉络表，欢迎纠错",
    author: "时间线爱好者",
    avatar: "线",
    tag: "用户投稿",
    replies: 33,
    likes: 289,
    time: "昨天",
  },
  {
    id: "d5",
    title: "关于「出处标注」这一点，建议统一格式",
    author: "求真小组",
    avatar: "真",
    tag: "规范讨论",
    replies: 21,
    likes: 178,
    time: "2 天前",
  },
];

export const footerColumns = [
  {
    title: "主题分区",
    links: ["娱乐观察", "网络热点", "商业动态", "科技圈"],
  },
  {
    title: "资料索引",
    links: ["合集归档", "图文资料", "话题存档", "更新时间线"],
  },
  {
    title: "关于本站",
    links: ["整理说明", "免责声明", "版权与纠错", "加入讨论"],
  },
];

export const trendTags: string[] = [
  "年度盘点",
  "时间线整理",
  "背景脉络",
  "热梗起源",
  "案例复盘",
  "出处标注",
  "图文存档",
  "长期追踪",
];